import { shipsInApp } from '../../shared/starterSet'
import { IS_NATIVE } from './platform'

/**
 * ☁️ v7.84 (the 9 Oct hosting split): the creature, boss and enemy art -
 * every file under public/creatures, public/bosses and public/enemies,
 * about 950 MiB of loops - is served from a Cloudflare R2 bucket behind
 * art.elementaldispatch.com (free egress), not by App Hosting. Every URL the
 * art modules hand out (data/art.ts, data/bossArt.ts, data/enemyArt.ts) and
 * the few literal art paths in the pages go through assetUrl(); the ?v=, m=,
 * r=, b= and d= busters ride along unchanged. Everything else (ui, forests,
 * music, title) stays on the site's own origin.
 *
 * Deploys never touch the bucket: `npm run art:sync` (scripts/art-sync.mjs)
 * uploads new or redrawn files and purges their cached copies, and
 * `npm run art:check` (first step of `npm test`) refuses a release whose art
 * folders changed since the last sync. `nuxt dev` keeps the local copies so
 * art can be previewed before it is synced.
 *
 * 📱 M3: an app bundle carries the starter set (shared/starterSet.ts) - the
 * posters, the enemy idles, the boss stills and the First Dispatch's kits
 * among the art - so those paths stay local in a native build, busters
 * included (the bundle's file server ignores the query), and every other
 * loop streams from the same host as on the web. Forests and music ship
 * whole and never pass through here. When a streamed loop cannot load
 * (offline, say), plugins/art-fallback.client.ts shows the bundled poster
 * or still instead (utils/artFallback.ts).
 */
export const ART_BASE = 'https://art.elementaldispatch.com'

const ART_PATH = /^\/(creatures|bosses|enemies)\//

/** The URL to render for an art path: '/bosses/umbrax-idle.webp?v=5-d1' ->
 * 'https://art.elementaldispatch.com/bosses/umbrax-idle.webp?v=5-d1'. Paths
 * outside the three folders, and URLs that are already absolute, come back
 * unchanged; so does an app bundle's own copy of a starter-set file. */
export function assetUrl(path: string): string {
  if (import.meta.dev || !ART_PATH.test(path)) return path
  if (IS_NATIVE && shipsInApp(path)) return path
  return `${ART_BASE}${path}`
}

/** The site path (and query) of an art URL - the inverse of assetUrl(), and
 * the key of the path-keyed tables (data/artFloor.json, data/bossFit.ts). */
export function artPath(url: string): string {
  return url.startsWith(`${ART_BASE}/`) ? url.slice(ART_BASE.length) : url
}
